export default __webpack_public_path__ + "static/media/d.140ef99b.jpg";